import { Box, styled } from '@mui/material';
import { isRtl } from '../../../../utils/utils';

export const StyledList = styled(Box)(({ theme }) => ({
  '& div': {
    marginLeft: isRtl(theme.direction) && '0 !important',
  }
}));